import http from "./apiServices"
import apiBaseUrl from "@utils/apiBaseUrl"

export const getAddresses = (q = "") => {
  return http.get("addresses", { params: { q }, baseURL: apiBaseUrl.replace("cms", "") })
}
